import * as React from 'react'
import Checkbox from '@mulesoft/anypoint-components/lib/Checkbox'
import './LogPointsConfigurationItem.css'

export type ValueProps = {
  label: string
  enabled: boolean
  itemKey: string
}

export type EventProps = {
  onLogPointActivate: () => void
}

export type Props = ValueProps & EventProps

export const LogPointsConfigurationItem = (props: Props) => (
  <div className="log-point-configuration-item">
    <Checkbox testId={props.itemKey} checked={props.enabled} onChange={props.onLogPointActivate}/>
    <span className="log-point-configuration-item-label" data-test-id={`${props.itemKey}-label`}>{props.label}</span>
  </div>
)